import { HttpHeaders } from '@angular/common/http';
import { clone, parseJWT } from '@approot/utilities';
import { environment } from '@root/environments/environment';
import { Channel } from 'phoenix';
import { UserSession } from '../auth/auth.service';
import {
  CallbacksAndParams,
  PresenceState,
  PresenceUser
} from './phoenix.service';

export function getHttpEndpoint(
  path: string,
  token: string
): [string, HttpHeaders] {
  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
  const endpoint = `${environment.phxEndpoint}${path}`.replace(/^ws/g, 'http');
  return [endpoint, headers];
}

export function joinChannel(
  channel: Channel,
  channelName: string,
  callbacks?: CallbacksAndParams
) {
  callbacks = {
    onShout: () => null,
    onJoin: () => null,
    ...callbacks
  };
  channel.on('shout', callbacks.onShout);

  channel
    .join()
    .receive('ok', resp => {
      callbacks.onJoin(resp);
      if (resp.error) {
        console.error(`Failed to join ${channelName}`, resp.error);
        channel.leave();
      } else {
        console.log(
          `Joined %c${channelName} %c${resp.message || JSON.stringify(resp)}`,
          `color: blue`,
          `color: green`
        );
      }
    })
    .receive('error', resp => {
      console.error(`Unable to join ${channelName}`, resp);
    })
    .receive('timeout', resp => {
      console.error(`Timeout when joining ${channelName}`, resp);
    });
  return channel;
}

export function getToken(cognito: UserSession): Record<string, any> {
  const token = cognito.getIdToken().getJwtToken();
  const vals = parseJWT(token);
  return {
    ...vals,
    token,
    superuser: vals['custom:isSuperuser'] === 'true',
    groups: vals['cognito:groups'],
    group: vals['cognito:groups']?.[0]
  };
}

export function leave(
  currentUsers: PresenceUser[],
  leaves: PresenceState
): PresenceUser[] {
  let users = clone(currentUsers);
  Object.keys(leaves).forEach(k => {
    leaves[k].metas.forEach(m => {
      users = users.filter(u => u.phx_ref !== m.phx_ref);
    });
  });
  return users;
}

export function join(
  currentUsers: PresenceUser[],
  joins: PresenceState
): PresenceUser[] {
  const users = clone(currentUsers);
  Object.keys(joins).forEach(k => {
    joins[k].metas.forEach(u => {
      users.push({
        ...u,
        online_at_str: timeToString(u.online_at),
        auth_time_str: timeToString(u.auth_time)
      });
    });
  });
  return users;
}

export function timeToString(timestamp: Date | string | number): string {
  const str = new Date(timestamp).toUTCString();
  const [_, dow, hhmm] = /^(\w\w\w).*?(\d\d:\d\d)/.exec(str);
  return `${dow} ${hhmm} UTC`;
}
